import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { withTranslation } from "react-i18next";
import { Row, Col, Container, Button } from "react-bootstrap";
import queryString from "query-string";
import { getCookies,setCookie } from "../../utils/cookies";
import ErrorCard from "../common/ErrorCard";
import GoogleCaptcha from "../common/GoogleCaptcha";
import RightArrow from "../../assets/images/right-arrow-white.svg";
import Carousel1 from "../../assets/images/MFA-Background-001.png";
import Carousel2 from "../../assets/images/MFA-Background-002.png";
import Carousel3 from "../../assets/images/MFA-Background-003.png";
import Carousel4 from "../../assets/images/MFA-Background-004.png";
import Carousel5 from "../../assets/images/MFA-Background-005.png";
import Carousel6 from "../../assets/images/MFA-Background-006.png";
import Carousel7 from "../../assets/images/MFA-Background-007.png";
import Carousel9 from "../../assets/images/reg9.jpg";
import downChevron from "../../assets/images/down-chevron.svg";
import http from "../../api/http-request";
import WithError from "../common/WithError";
import {
  getLoginUrl,
  getRoutePath,
  getNestedObject,
  isPasswordFormatValid,pageNotFound,randomCount,preventNonDigitCharacters,formatPhoneNumber,getPhoneNumberFromFormattedString
} from "../../utils/common";
import PasswordRequirements from "../PasswordRequirements";
import PasswordField from "../common/PasswordField";
import Radio from "../common/Radio";
import i18n from "../../i18n";
import SomethingWentWrong from "../common/SomethingWentWrong";
import SystemDownTime from "../common/SystemDownTime";
import ReactCodeInput from 'react-verification-code-input';

class Registration extends Component {
  constructor(props) {
    super(props);
    this.passwordInputRef = React.createRef();
    this.confirmPasswordInputRef = React.createRef();
    this.telephoneNumberInputRef = React.createRef();
    this.verificationInputRef = React.createRef();
    this.state = {
      registrationToken: "",
      googleCaptchaToken: "",
      givenName: "",
      googleCaptchaResponse: "",
      sn: "",
      userName: "",
      mail: "",
      confirmEmail: "",
      password: "",
      errorText: "",
      errorArray: [],
      confirmPasswordError: "",
      confirmPassword: "",
      passwordError: "",
      formSubmitted: false,
      captchaReset: false,
      hideRegistration: "",
      verificationTokenExpired: false,
      disableCaptcha: false,
      language:"en_US",
      availableLanguages:["en_US", "es"],
      selectedOption:getCookies("ctsessionlanguage") || "en_US",
      isSystemError:false,
      isSomethingError:false,
      carouselImages: [{'image':Carousel1},{'image':Carousel2},{'image':Carousel3},{'image':Carousel4},{'image':Carousel5},{'image':Carousel6},{'image':Carousel7},{'image':Carousel9}],
      imageIndex:0,
      telephoneNumber: "",
      telephoneNumberUSFormatted: "",
      screen:1,
      numberFocus:false,
      showSuccessMsg: "",
      showErrorMsg: false,
      verificationCode: "",
      verificationOption:"",
      verificationPlaceholder:['0','0','0','0','0','0','0','0'],
      authenticateData: {},
      seeMore:false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.renderPageByToken();
    const {
      location: { search }
    } = this.props;
    const params = queryString.parse(search);
    let ctAppEnv;
    const locationUrl = window.location.origin;
    if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      ctAppEnv = 'ctapproutedev';
    } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
      ctAppEnv = 'ctapproutestg';
    } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
      ctAppEnv = 'ctapproutedevc';
    } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
      ctAppEnv = 'ctapproutepsup';    
    } else if (locationUrl.indexOf('login.ct.gov') > 0) {
      ctAppEnv = 'ctapproute';
    }
    if (params.goto) {
      setCookie(`${ctAppEnv}`, search);
    }
    if (params.language) {
      setCookie("ctsessionlanguage", params.language);
    }
    this.getAuthToken();
    
    }
    componentDidUpdate(prevProps,prevState){
      
      const langP = i18n.language || "en_US";
      if(prevState.selectedOption !== langP){
        this.setState({
          selectedOption:langP
        })
      }
    }

    getAuthToken = () => {
      http(
        {
          url: "authenticate?service=selfRegistration&authIndexType=service&authIndexValue=SelfRegistration",
          method: "POST"
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        if (res && res.status === 200 && res.data.callbacks[0].type === 'ValidatedCreateUsernameCallback') {
          this.setState({
            authenticateData: res.data
          });
        }
      });
    }

    genericResponse = (res) => {
      if(getNestedObject(res, ["data", "callbacks"])) {
        const {
          data: {
            callbacks
          }
        } = res;
        if(callbacks) {
          if (callbacks[0].type === 'ReCaptchaCallback') {
            const recaptchaSiteKey = res.data.callbacks[0].output[0].value;
            if (recaptchaSiteKey) {
              this.setState({
                googleCaptchaToken: recaptchaSiteKey,
                authenticateData: res.data,
                formSubmitted: false,
                screen:2
              });
            } else {
              this.setState({
                showSuccessMsg: true
              });
            }
          } else if(callbacks[0].output[0].value === 'OTP_COLLECTOR_SKIP'){
            this.setState({
              screen:3,
              authenticateData: res.data,
              verificationOption:res.data.callbacks[1].output[0].value,
            });
            window.scrollTo({
              behavior: "smooth",
              top: 0
            });
            if(callbacks[4]) {
              if(callbacks[4].output[0].value === 'OTP_VALIDATION_FAILED') {
                this.setState({
                  verificationCodeError: "pages.forgotUserName.invalidVerificationCode"
                });
              }
            }
          } else if(callbacks[0].output[0].value === 'REGISTRATION_SUCCESS') {
            this.setState({
              screen:4
            });
            window.scrollTo({
              behavior: "smooth",
              top: 0
            });
            } else if(callbacks[0].type === 'ValidatedCreateUsernameCallback' && callbacks[2].type === 'StringAttributeInputCallback') {
              let errorArray = [];
              if(callbacks[0].output[1].value.length > 0) {
                if(JSON.parse(res.data.callbacks[0].output[1].value).policyRequirement === 'LOWERCASE_UNIQUE') {
                  let errorData = {};
                  errorData.property = 'userName';
                  errorData.policyRequirements = [];
                  errorData.policyRequirements.push({ policyRequirement: 'UNIQUE' });
                  errorArray.push(errorData);
                  this.setState({
                    errorArray: errorArray,
                    authenticateData: res.data
                  });
                  window.scrollTo({
                    behavior: "smooth",
                    top: 0
                  });
                }
              }
              if(callbacks[2].output[4].value.length > 0) {
                if(JSON.parse(res.data.callbacks[2].output[4].value).policyRequirement === 'LOWERCASE_UNIQUE') {
                  let errorData = {};
                  errorData.property = 'mail';
                  errorData.policyRequirements = [];
                  errorData.policyRequirements.push({ policyRequirement: 'UNIQUE' });
                  errorArray.push(errorData);
                  this.setState({
                    errorArray: errorArray,
                    authenticateData: res.data
                  });
                  window.scrollTo({
                    behavior: "smooth",
                    top: 0
                  });
                }
              }
            }
        }
      } else if (getNestedObject(res, ["data", "detail", "failureUrl"])) {
        const {
          data: {
            detail: { failureUrl }
          }
        } = res;
        if (failureUrl.includes("https://")) {
          window.location.href = sanitizeUrl(`${res.data.detail.failureUrl}`);
          return;
        }
        let errorMsg = "";
        switch (failureUrl) {
          case "INVALID_CREDENTIALS":
            errorMsg = "common.errors.wrongCredentials";
            break;
          case "ACCOUNT_LOCKED":
            errorMsg = "common.errors.accountLocked";
            break;
          case "ACCOUNT_ALREADY_LOCKED":
            errorMsg = "common.errors.accountAlreadyLocked";
            break;
          case "INTERNAL_ERROR":
            errorMsg = "common.errors.internalError";
            break;
          case "MAX_RETRY_EXCEEDED":
            errorMsg = "common.errors.maxVerifyAttempt";
            break;
          case "MAX_RESEND_EXCEEDED":
            errorMsg = "common.errors.maxResendAttempt";
            break;
            case "USER_NOT_FOUND":
            errorMsg = "pages.forgotUserName.userNotFound";
            break;
          default:
            errorMsg = "common.errors.internalError";
            break;
        }
        this.showError(errorMsg);
        this.setState({
          screen:1,
          showGoogleCaptcha:false,
          showSuccessMsg:false,
          showErrorMsg:false,
          verificationCode:'',
          selectedOption:'',
          verificationOption: ''
        });
        this.googleCaptchaReset();
        this.getAuthToken();
      } else if(res.status === 401 && res.data.code === 401 && res.data.message === 'Session has timed out'){
        this.showError("common.errors.sessionTimedOut");
        this.setState({
          screen:1,
          showGoogleCaptcha:false,
          showSuccessMsg:false,
          showErrorMsg:false,
          verificationCode:'',
          selectedOption:'',
          verificationOption: ''
        });
        this.getAuthToken();
      }
    }

    onMobileNumberChange = (e) => {
      const currentValue = e.target.value.trim();
      this.setState((prevState) => ({
        ...prevState,
        telephoneNumber: formatPhoneNumber(currentValue, prevState.phoneNumber)
      }));
    };
  
    handleKeyPress = (e) => {
      preventNonDigitCharacters(e);
    };

  renderPageByToken = () => {
    const {
      location: { search }
    } = this.props;
    const params = queryString.parse(search);
    this.displayRandomImage();

    let environment;
    const locationUrl = window.location.origin;
    if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      environment = 'ctapproutedev';
    } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
      environment = 'ctapproutestg';
    } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
      environment = 'ctapproutedevc';
    } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
      environment = 'ctapproutepsup';    
    } else if (locationUrl.indexOf('login.ct.gov') > 0) {
      environment = 'ctapproute';
    }
    
    const { code, token } = queryString.parse(search);
    let ctapproute;
    Object.keys(params).forEach((key) => {
      if(key === environment){
        ctapproute = params[key];
      }
    });
    if (code && token) {
      this.setState({ hideRegistration: false });
      this.verifyUserFromMailLink(code, token);
    } else {
      //this.getRegistrationToken();
      this.setState({ hideRegistration: true });
    }
    if (ctapproute) {
      setCookie(`${environment}`, ctapproute);
    }
  };
  displayRandomImage = () => {
    this.setState({
      imageIndex: randomCount()
    });
  };

  verifyUserFromMailLink = (code, token) => {
    http(
      {
        url: "selfservice/registration?_action=submitRequirements",
        data: {
          input: {
            token,
            code
          },
          token
        },
        method: "POST"
      },
      {
        "X-OpenIDM-NoSession": true,
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.type === 'updateIdentityVerification') {
        const { history } = this.props;
        history.push(sanitizeUrl(`${getRoutePath}/verificationSuccess`));
      }
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        this.setState({
          verificationTokenExpired: true
        });
      }
    });
  };

  checkUsername =() => {
    const {
      givenName,
      sn,
      userName,
      mail,
      password,
      selectedOption,telephoneNumber, authenticateData
    } = this.state;
      
    this.setState({
      errorText: ""
    });

    let environment;
    let ctAppSource;
    const locationUrl = window.location.origin;
    if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      environment = 'ctapproutedev';
    } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
      environment = 'ctapproutestg';
    } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
      environment = 'ctapproutedevc';
    } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
      environment = 'ctapproutepsup';    
    } else if (locationUrl.indexOf('login.ct.gov') > 0) {
      environment = 'ctapproute';
    }
    
    if(getCookies(`${environment}`)){
      ctAppSource = getCookies(`${environment}`);
      const urlArray = `?${ctAppSource.split("?")[1]}`;
      const params = queryString.parse(urlArray);
      if(params.spEntityID){
        ctAppSource = params.spEntityID.replace('http://','').replace('https://','').split(/[/?#]/)[0];
      } else {
        ctAppSource = params.goto.replace('http://','').replace('https://','').split(/[/?#]/)[0];
      } 
    }
    if(telephoneNumber){
    authenticateData.callbacks[0].input[0].value = userName;
    authenticateData.callbacks[1].input[0].value = password;
    authenticateData.callbacks[2].input[0].value = mail;
    authenticateData.callbacks[3].input[0].value = '+1' + telephoneNumber.replace(/[^A-Z0-9]/gi, '');
    authenticateData.callbacks[4].input[0].value = selectedOption === "en_US" ? "en" : selectedOption;
    authenticateData.callbacks[5].input[0].value = givenName.trim();
    authenticateData.callbacks[6].input[0].value = sn.trim();
    authenticateData.callbacks[7].input[0].value = ctAppSource;
  } else {
    authenticateData.callbacks[0].input[0].value = userName;
    authenticateData.callbacks[1].input[0].value = password;
    authenticateData.callbacks[2].input[0].value = mail;
    authenticateData.callbacks[3].input[0].value = "";
    authenticateData.callbacks[4].input[0].value = selectedOption === "en_US" ? "en" : selectedOption;
    authenticateData.callbacks[5].input[0].value = givenName.trim();
    authenticateData.callbacks[6].input[0].value = sn.trim();
    authenticateData.callbacks[7].input[0].value = ctAppSource;
  }

  http(
    {
      url: "authenticate?service=selfRegistration&authIndexType=service&authIndexValue=SelfRegistration",
      method: "POST",
      data: authenticateData
    },
    {
      "Accept-API-Version": "protocol=1.0,resource=2.1"
    }
  ).then((res) => {
      this.genericResponse(res);
      // if (res.status === 200 && res.data && res.data.failedPolicyRequirements.length === 0 && res.data.result === true) {
      //  this.getRegistrationToken();
      //  this.setState({
      //    formSubmitted: false,
      //    screen:2
      //  });
      // }
      // const failedPolicyRequirements = getNestedObject(res, [
      //   "data",
      //   "failedPolicyRequirements"
      // ]);
      // if (failedPolicyRequirements.length > 0) {
      //   this.setState({
      //     errorArray: failedPolicyRequirements
      //   });
      //   this.googleCaptchaReset();
      //   window.scrollTo({
      //     behavior: "smooth",
      //     top: 0
      //   });
      // } 
      // else if (res.status === 200 && res.data && res.data.type === 'CTEmailValidation') {
      //   history.push(sanitizeUrl(`${getRoutePath}/registrationSuccess`));
      // } 
      // else if (res.status === 200 && res.data && res.data.failedPolicyRequirements.length === 0 && res.data.result === true) {
      // this.getRegistrationToken();
      // this.setState({
      //   formSubmitted: false,
      //   screen:2
      // })
      // } 
      // else if (
      //   res.status === 400 &&
      //   res.data.message === "Snapshot token is invalid"
      // ) {
      //   this.getRegistrationToken();
      //   this.googleCaptchaReset();
      //   this.showError("pages.registration.snapshotErrorPage");
      // } 
      // else if(res.status === 200 && res.data && typeof res.data === 'string'){
      //   pageNotFound(res);
      // }
      // else {
      //   this.googleCaptchaReset();
      //   this.showError("pages.registration.registrationFailed");
      // }
    });
  };

  onRegister = (e) => {
    this.setState({
      errorArray: [],
      errorText: "",
      formSubmitted:true
    });
    e.preventDefault();
    const {
      givenName,
      sn,
      userName,
      mail,
      confirmEmail,
      password,
      confirmPassword,telephoneNumber
    } = this.state;
    const hasGivenName = this.isFormFieldValid(givenName, "givenNameError");
    const hasSn = this.isFormFieldValid(sn, "snError");
    const hasUserName = this.isFormFieldValid(userName, "userNameError");
    const hasMail = this.isFormFieldValid(mail, "emailError");
    const hasConfirmMail = this.isFormFieldValid(
      confirmEmail,
      "confirmEmailError"
    );
    const hasPassword = this.isFormFieldValid(password, "passwordError");
    const hasConfirmPassword = this.isFormFieldValid(
      confirmPassword,
      "confirmPasswordError"
    );

    if (
      hasGivenName ||
      hasSn ||
      hasUserName ||
      hasMail ||
      hasConfirmMail ||
      hasPassword ||
      hasConfirmPassword
    ) {
      this.showError("common.errors.required");
    } 
    // else if (!disableCaptcha && !googleCaptchaResponse) {
    //   this.showError("common.errors.recaptchaError");
    // } 
    else {
      window.scrollTo({
        behavior: "smooth",
        top: 0
      });
      if(telephoneNumber !== '' && telephoneNumber.length >= 14){
        this.setState({
          telephoneNumberUSFormatted: getPhoneNumberFromFormattedString(
             telephoneNumber
           )
        })
        this.checkUsername();
      } else if(telephoneNumber === '') {
        this.checkUsername();
      } else {
        this.setState({
          telephoneNumberError: "pages.editNumberPopup.mobileNumberInvalid"
        });
        this.showError("pages.editNumberPopup.mobileNumberInvalid");
        //this.telephoneNumberInputRef.current.focus();
      }
    }
  };


  formSubmit = () => {
    const {
      googleCaptchaResponse,disableCaptcha,googleCaptchaToken,authenticateData
    } = this.state;

    if (!disableCaptcha && !googleCaptchaResponse) {
      this.showError("common.errors.recaptchaError");
    } else {

      this.setState({
        errorText: ""
      });
      //let ctAppSource;
      // let enviroment;
      // const locationUrl = window.location.origin;
      // if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      //   enviroment = 'ctapproutedev';
      // } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
      //   enviroment = 'ctapproutestg';
      // } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
      //   enviroment = 'ctapproutedevc';
      // } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
      //   enviroment = 'ctapproutepsup';    
      // } else if (locationUrl.indexOf('login.ct.gov') > 0) {
      //   enviroment = 'ctapproute';
      // }
      
      // if(getCookies(`${enviroment}`)){
      //   ctAppSource = getCookies(`${enviroment}`);
      //   const urlArray = `?${ctAppSource.split("?")[1]}`;
      //   const params = queryString.parse(urlArray);
      //   if(params.spEntityID){
      //     ctAppSource = params.spEntityID.replace('http://','').replace('https://','').split(/[/?#]/)[0];
      //   } else {
      //     ctAppSource = params.goto.replace('http://','').replace('https://','').split(/[/?#]/)[0];
      //   } 
      // }
      authenticateData.callbacks[0].input[0].value = googleCaptchaResponse;
      authenticateData.callbacks[0].output[0].value = googleCaptchaToken;
      http(
        {
          url: "authenticate?service=selfRegistration&authIndexType=service&authIndexValue=SelfRegistration",
          data: authenticateData,
          method: "POST"
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
        // const failedPolicyRequirements = getNestedObject(res, [
        //   "data",
        //   "detail",
        //   "failedPolicyRequirements"
        // ]);
        // if (failedPolicyRequirements) {
        //   this.setState({
        //     errorArray: failedPolicyRequirements
        //   });
        //   this.googleCaptchaReset();
        //   window.scrollTo({
        //     behavior: "smooth",
        //     top: 0
        //   });
        // } 
        // else if (res.status === 200 && res.data && res.data.type === 'codeValidation') {
        //   const token = getNestedObject(res, ["data", "token"]);
        //   if (token) {
        //     this.setState({
        //       registrationToken: token
        //     });
        //   }
        //   this.setState({
        //     screen:3,
        //     verificationOption:res.data.requirements.properties.verificationCode.description
        //   });
        //   window.scrollTo({
        //     behavior: "smooth",
        //     top: 0
        //   });
        // }
        // else if (res.status === 200 && res.data && res.data.type === 'EmailVerifyStatus' && res.data.tag === 'initial') {
        //   this.setState({
        //     screen:5
        //   });
        //   window.scrollTo({
        //     behavior: "smooth",
        //     top: 0
        //   });
        // }
        // else if (
        //   res.status === 400 &&
        //   res.data.message === "Snapshot token is invalid"
        // ) {
        //   this.getRegistrationToken();
        //   this.googleCaptchaReset();
        //   this.showError("pages.registration.snapshotErrorPage");
        // } 
        // else if(res.status === 200 && res.data && typeof res.data === 'string'){
        //   pageNotFound(res);
        // }
        // else {
        //   this.googleCaptchaReset();
        //   this.showError("pages.registration.registrationFailed");
        // }
      });
    }
    };

  googleCaptchaReset = () => {
    const { disableCaptcha } = this.state;
    if (!disableCaptcha) {
      this.setState({
        captchaReset: true,
        googleCaptchaResponse: ""
      });
      setTimeout(() => {
        this.setState({
          captchaReset: false
        });
      }, 100);
    }
  };

  showError = (errorText) => {
    this.setState({
      errorText
    });
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  };

  onCaptchaChange = (value) => {
    this.setState({
      googleCaptchaResponse: value
    });
  };

  onFirstAndLastNameChange = (e, key) => {
    const {
      target: { value }
    } = e;
    if (value.match(/^[a-zA-Z '`,.-]*$/)) {
      this.setState({
        [key]: value
      });
    }
  };

  isFormFieldValid = (e, key) => {
    let value = e.target ? e.target.value : e;
    const { mail, confirmEmail, password, confirmPassword } = this.state;

    let errorMsg = "";
    switch (key) {
      case "givenNameError":
        if (value.length <= 0 || (/^\s*$/.test(value))) {
          errorMsg = "common.errors.firstNameError";
        }
        break;
      case "snError":
        if (value.length <= 0 || (/^\s*$/.test(value))) {
          errorMsg = "common.errors.lastNameError";
        }
        break;
      case "userNameError":
        let regExp = /[a-zA-Z]/g;
        value = e.target ? e.target.value.trim() : e;
        if(value.length < 5  || value.length > 30){
          errorMsg = "common.errors.userNameLength";
        }
        else if((!regExp.test(value) && value.length >= 5 && value.length <= 30)){
          errorMsg = "common.errors.userNameAtleastAlphabet";
        }
        break;
      case "emailError":
        value = e.target ? e.target.value.trim() : e;
        if (
          value.length <= 0 ||
          !value.match(
            /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/
          )
        ) {
          errorMsg = "common.errors.emailError";
        }
        break;
      case "confirmEmailError":
        value = e.target ? e.target.value.trim() : e;
        if (value.length <= 0) {
          errorMsg = "common.errors.confirmEmailError";
        } else if (mail !== confirmEmail) {
          errorMsg = "common.errors.mailsNotMatchError";
        }
        break;
      case "passwordError":
        value = e.target ? e.target.value.trim() : e;
        if (value.length <= 0) {
          errorMsg = "common.errors.noPasswordError";
        } else if (isPasswordFormatValid(value)) {
          errorMsg = "common.errors.invalidFormat";
        }
        break;
      case "confirmPasswordError":
        value = e.target ? e.target.value.trim() : e;
        if (value.length <= 0) {
          errorMsg = "common.errors.noConfirmPasswordError";
        } else if (password !== confirmPassword) {
          errorMsg = "common.errors.passwordsError";
        }
        break;
      default:
        errorMsg = "";
        break;
    }
    this.setState({
      [key]: errorMsg
    });
    return errorMsg;
  };

  onUserNameChange = (e, key) => {
    const value = e.target.value.trim();
    if (!value.match(/[\\+/""=&@#'*%;, ]/g)) {
      this.setState({
        [key]: value.toLowerCase()
      });
    }
  };
  disableCopyPaste = (e) => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
  }

  goBackUrl = () => {
    this.setState({screen:1,
      confirmPassword:'',
      password:''
    });
    this.getAuthToken();
  }
  
  onSubmit = () => {
    this.formSubmit();
  }

  onVerify = (e) => {
    e.preventDefault();
    const { verificationCode, authenticateData } = this.state;
    if (verificationCode === "") {
      this.setState({
        verificationCodeError: "pages.login.verificationCodeRequired"
      });
      //this.verificationInputRef.current.focus();
    } else {

      this.verificationInputRef.current.__clearvalues__();
      this.setState({
        verificationCodeError: ""
      });
      authenticateData.callbacks[2].input[0].value = verificationCode;
      http(
        {
          url: "authenticate?service=selfRegistration&authIndexType=service&authIndexValue=SelfRegistration",
          data: authenticateData,
          method: "POST"
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
      });
    }
  };

  resendVerify = (e) => {
    e.preventDefault();
    this.verificationInputRef.current.__clearvalues__();
    this.setState({
      verificationCode:"",
      verificationCodeError:""
    });
    const { authenticateData } = this.state;
    authenticateData.callbacks[3].input[0].value = 1;
    this.setState({
      errorText: ""
    });
      http(
        {
          url: "authenticate?service=selfRegistration&authIndexType=service&authIndexValue=SelfRegistration",
          data: authenticateData,
          method: "POST"
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
      });
    };

  skipUrl = (e) => {
    e.preventDefault();
    const { authenticateData } = this.state;
    authenticateData.callbacks[3].input[0].value = 2;
      http(
        {
          url: "authenticate?service=selfRegistration&authIndexType=service&authIndexValue=SelfRegistration",
          data: authenticateData,
          method: "POST"
        },
        {
          "Accept-API-Version": "protocol=1.0,resource=2.1"
        }
      ).then((res) => {
        this.genericResponse(res);
      });
      
    };

    handleChange = (vals) => {
      this.setState({
        verificationCode:vals
      })
    };
    seeMoreHandler = () =>{
      this.setState({
        seeMore:!this.state.seeMore
      })
    }
 
  render() {
    const { t } = this.props;
    const {
      googleCaptchaToken,
      givenName,
      sn,
      userName,
      mail,
      password,
      confirmPassword,
      errorText,
      givenNameError,
      snError,
      userNameError,
      emailError,
      confirmEmail,
      confirmEmailError,
      passwordError,
      confirmPasswordError,
      errorArray,
      captchaReset,
      hideRegistration,
      verificationTokenExpired,
      screen,
      disableCaptcha,
      formSubmitted,
      availableLanguages,
      selectedOption,
      isSystemError,
      isSomethingError,carouselImages,
      imageIndex,
      telephoneNumber,
      telephoneNumberError,
      numberFocus,
      seeMore,
      verificationCodeError,verificationOption,verificationPlaceholder
    } = this.state;
    return (
      <>
        {!isSystemError && !isSomethingError && (
        <div
          className={`${
            (errorText || errorArray.length > 0) && "has-error"
          }`} style={{flexGrow:1}}
        >
          <div className={screen === 1 ? "wrapper register one" : "wrapper register"} 
          style={{ backgroundImage: `url(${carouselImages[imageIndex].image})` }}
          >
          
              {(errorText || errorArray.length > 0) && (
            <WithError errors={errorText} errorArray={errorArray} />
          )}
            <Container
              className={`container wrapper__container ${
                (errorText || errorArray.length > 0) && "haserror"
              }`}
            >
              <Row>
              <Col lg={{ span: 8 }} className="register-right-content">    
                <div className="register__right-container">
                  <div className="register__right-container-heading ">{t("pages.login.welcomeText")}</div>
                  <div className={seeMore ? 'register__right-container-service block show' : 'register__right-container-service block'}>
                    <span className="register__right-container-subheading">{t("pages.login.serviceTextOne")} </span>
                    {/* <span className="register__right-container-subheading hide">{t("pages.login.serviceTextTwo")} </span> */}
                    <span className="register__right-container-subheading register__right-container-subheading-bold block hide">
                      {t("pages.login.needAnAccount") + " "}
                      <Link to={`${getRoutePath}/registration`} aria-label={t("pages.login.createOne")}>
                        {t("pages.login.createOne")}
                      </Link>
                    </span>
                  </div>
                  <div className="bottom-section">
                    <div className="separator"></div>
                    <div className="register__right-container-subhead ">{t("pages.login.security")}</div>
                    <span className="register__right-container-subcontent block">{t("pages.login.securityDesc")} </span>
                    <a className="register__right-container-link" href="https://portal.ct.gov/ctidentity/mfa-faq?language=en_US" target="_blank" aria-label={t("pages.login.readMore")}>{t("pages.login.readMore")}</a>
                  </div>
                  <p className={seeMore ? 'open see-more mt-3': 'see-more mt-3'} aria-label="" tabIndex={0} role="button" onClick={this.seeMoreHandler} onKeyPress={this.seeMoreHandler}><span className="more">{t("pages.login.seeMore")}</span><span className="less">{t("pages.login.seeLess")}</span><img src={downChevron} alt="down-chevron"></img></p>
                </div>
              </Col>
                <Col lg={{ span: 4 }}>
                  <div className="wrapper__container-card">
                    <div className="wrapper__container-card-body">
                      {hideRegistration !== "" && hideRegistration && (
                        <>
                        {screen === 1 && (
                          <>
                          <h1 className="wrapper__container-card-body-title">
                            {t("pages.registration.singUp")}
                          </h1>
                          <Form>
                        
                          
                            <Form.Row>
                              <Col className="pr-2" lg={{ span: 6 }}>
                                <Form.Group controlId="firstName">
                                  <Form.Label>
                                    {t("pages.registration.firstName")}
                                  </Form.Label>
                                  <Form.Control
                                    onChange={(e) => {
                                      this.onFirstAndLastNameChange(
                                        e,
                                        "givenName"
                                      );
                                    }}
                                    autoFocus
                                    value={givenName}
                                    autoFocus
                                    maxLength="40"
                                    onBlur={(e) => {
                                      this.isFormFieldValid(e, "givenNameError");
                                    }}
                                    className={
                                      givenNameError ? "error-input" : undefined
                                    }
                                    aria-required
                                    aria-invalid={!!givenNameError}
                                    aria-describedby="firstname-error"
                                  />
                                  <p className="error-text" id="firstname-error">
                                    {givenNameError && t(givenNameError)}
                                  </p>
                                </Form.Group>
                              </Col>
                              <Col className="pl-2" lg={{ span: 6 }}>
                                <Form.Group controlId="lastName">
                                  <Form.Label>
                                    {t("pages.registration.lastName")}
                                  </Form.Label>
                                  <Form.Control
                                    onChange={(e) => {
                                      this.onFirstAndLastNameChange(e, "sn");
                                    }}
                                    value={sn}
                                    maxLength="80"
                                    onBlur={(e) => {
                                      this.isFormFieldValid(e, "snError");
                                    }}
                                    className={
                                      snError ? "error-input" : undefined
                                    }
                                    aria-required
                                    aria-invalid={!!snError}
                                    aria-describedby="lastname-error"
                                  />
                                  <p className="error-text" id="lastname-error">
                                    {snError && t(snError)}
                                  </p>
                                </Form.Group>
                              </Col>
                            </Form.Row>

                            <Form.Group controlId="userName">
                              <Form.Label>
                                {t("pages.registration.userName")}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                onChange={(e) => {
                                  this.onUserNameChange(e, "userName");
                                }}
                                value={userName}
                                maxLength="30"
                                onBlur={(e) => {
                                  this.isFormFieldValid(e, "userNameError");
                                }}
                                className={
                                  userNameError ? "error-input" : undefined
                                }
                                aria-required
                                autoComplete="off"
                                aria-invalid={!!userNameError}
                                aria-describedby="username-error"
                              />
                              <p className="error-text" id="username-error">
                                {userNameError && t(userNameError)}
                              </p>
                            </Form.Group>
                            

                            <Form.Group controlId="email">
                              <Form.Label>
                                {t("pages.registration.email")}
                              </Form.Label>
                              <Form.Control
                                type="email"
                                onChange={(e) => {
                                  this.setState({
                                    mail: e.target.value.trim().toLowerCase()
                                  });
                                }}
                                onBlur={(e) => {
                                  this.isFormFieldValid(e, "emailError");
                                }}
                                value={mail}
                                aria-required
                                className={emailError ? "error-input" : undefined}
                                aria-invalid={!!emailError}
                                aria-describedby="email-error"
                              />
                              <p className="context">
                              {t("pages.registration.emailContext")}
                              </p>
                              <p className="error-text" id="email-error">
                                {emailError && t(emailError)}
                              </p>
                            </Form.Group>

                            <Form.Group controlId="confirmEmail">
                              <Form.Label>
                                {t("pages.registration.confirmEmail")}
                              </Form.Label>
                              <Form.Control
                                type="email"
                                onChange={(e) => {
                                  const value = e.target.value
                                    .trim()
                                    .toLowerCase();
                                  this.setState(
                                    {
                                      confirmEmail: value
                                    },
                                    () => {
                                      this.isFormFieldValid(
                                        value,
                                        "confirmEmailError"
                                      );
                                    }
                                  );
                                }}
                                onBlur={(e) => {
                                  this.isFormFieldValid(e, "confirmEmailError");
                                }}
                                value={confirmEmail}
                                className={
                                  confirmEmailError ? "error-input" : undefined
                                }
                                aria-required
                                aria-invalid={!!confirmEmailError}
                                aria-describedby="confirm-email-error"
                                onCopy={(e) => {
                                  this.disableCopyPaste(e);
                                }}
                                onPaste={(e) => {
                                  this.disableCopyPaste(e);
                                }}
                              />
                              <p className="error-text" id="confirm-email-error">
                                {confirmEmailError && t(confirmEmailError)}
                              </p>
                            </Form.Group>
                            <Form.Group controlId="telephoneNumber">
                              <Form.Label>
                                {t("pages.registration.mobileNumber")}
                              </Form.Label>
                              <Form.Control
                                ref={this.telephoneNumberInputRef}
                                onKeyDown={this.handleKeyPress}
                                placeholder={!numberFocus ? "(###) ###-####" : ""}
                                onFocus={() => {
                                  this.setState({
                                    numberFocus: true
                                  });
                                }}
                                onBlur={() => {
                                  this.setState({
                                    numberFocus: false
                                  });
                                }}
                                onChange={this.onMobileNumberChange}
                                value={telephoneNumber}
                                aria-required
                                className={
                                  telephoneNumberError ? "error-input" : undefined
                                }
                                aria-invalid={!!telephoneNumberError}
                                aria-describedby="mobile-number-error"
                              />
                              <p className="context">
                              {t("pages.registration.mobileUS")}
                              </p>
                              <p className="error-text" id="mobile-number-error">
                                {telephoneNumberError && t(telephoneNumberError)}
                              </p>
                            </Form.Group>
                            <div className="pref-language">
                            {t("pages.registration.preferredLanguage")}
                            </div>
                            <Form.Row>
                              
                              {availableLanguages.map((language, index) => (
                              <Col >
                              <Radio
                              key={language}
                              name={`language-${language}`}
                              label={`pages.changePreferredLang.languages.${language}`}
                              value={language}
                              isChecked={language === selectedOption}
                              noPadding={true}
                              ariaLabel={`pages.registration.prefAriaLabel.languages.${language}`}
                              handleChange={(value) => {
                                
                                i18n.changeLanguage(value);
                                setCookie("ctsessionlanguage", value);
                                this.setState({
                                  selectedOption: value
                                });
                                let environment;
                                const locationUrl = window.location.origin;
                                if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
                                  environment = 'ctapproutedev';
                                } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
                                  environment = 'ctapproutestg';
                                } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
                                  environment = 'ctapproutedevc';
                                } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
                                  environment = 'ctapproutepsup';    
                                } else if (locationUrl.indexOf('login.ct.gov') > 0) {
                                  environment = 'ctapproute';
                                }
                                const ctapproute = getCookies(`${environment}`);
                                if (ctapproute && ctapproute.includes("language")) {
                                  const urlArray = `?${ctapproute.split("?")[1]}`;
                                  const params = queryString.parse(urlArray);
                                  params.language = value;
                                  const url = `?${decodeURIComponent(queryString.stringify(params))}`;
                                  setCookie(`${process.env.environment}`, url);
                                }
                              }}
                              
                            />
                        </Col>
                            ))}
                            </Form.Row>
                          
                            <Form.Row>
                              <Col lg={{ span: 12 }}>
                                <Form.Group controlId="passWord">
                                  <Form.Label>
                                    {t("pages.registration.password")}
                                  </Form.Label>
                                  <PasswordField
                                    onChange={(value) => {
                                      this.setState({
                                        password: value
                                      },
                                      () => {
                                        if (confirmPassword !== '') {
                                          this.isFormFieldValid(
                                            value,
                                            "confirmPasswordError"
                                          );
                                        }
                                      });
                                    }}
                                    onBlur={(e) => {
                                      this.isFormFieldValid(e, "passwordError");
                                    }}
                                    password={password}
                                    className={
                                      passwordError ? "error-input" : undefined
                                    }
                                    aria-required
                                    ariaInvalid={!!passwordError}
                                    ariaDescribedby="password-error password-requirements"
                                    myRef={this.passwordInputRef}
                                  />
                                </Form.Group>
                                <p className="error-text" id="password-error">
                                  {passwordError && t(passwordError)}
                                </p>
                              </Col>
                              <Col lg={{ span: 12 }}>
                                <Form.Group controlId="confirmPassWord">
                                  <Form.Label>
                                    {t("pages.registration.confirmPassword")}
                                  </Form.Label>

                                  <PasswordField
                                    onChange={(value) => {
                                      this.setState(
                                        {
                                          confirmPassword: value
                                        },
                                        () => {
                                          this.isFormFieldValid(
                                            value,
                                            "confirmPasswordError"
                                          );
                                        }
                                      );
                                    }}
                                    onBlur={(e) => {
                                      this.isFormFieldValid(
                                        e,
                                        "confirmPasswordError"
                                      );
                                    }}
                                    password={confirmPassword}
                                    className={
                                      confirmPasswordError
                                        ? "error-input"
                                        : undefined
                                    }
                                    aria-required
                                    ariaInvalid={!!confirmPasswordError}
                                    ariaDescribedby="confirm-password-error"
                                    myRef={this.confirmPasswordInputRef}
                                    onCopy={(e) => {
                                      this.disableCopyPaste(e);
                                    }}
                                    onPaste={(e) => {
                                      this.disableCopyPaste(e);
                                    }}
                                  />
                                </Form.Group>
                                <p
                                  className="error-text"
                                  id="confirm-password-error"
                                >
                                  {confirmPasswordError &&
                                    t(confirmPasswordError)}
                                </p>
                              </Col>
                            </Form.Row>
                          
                            <PasswordRequirements
                              password={password}
                              formSubmitted={formSubmitted}
                            />
                            {/* {!disableCaptcha && (
                              <div className="google-captcha">
                                <div className="google-captcha__box">
                                  {googleCaptchaToken && (
                                    <GoogleCaptcha
                                      sitekey={googleCaptchaToken}
                                      onCaptchaChange={this.onCaptchaChange}
                                      captchaReset={captchaReset}
                                    />
                                  )}
                                </div>
                              </div>
                            )} */}
                            <Button
                              className="wrapper__container-card-body-submit"
                              size="lg"
                              variant="primary"
                              block
                              type="submit"
                              onClick={(e) => this.onRegister(e)}
                            >
                              {t("pages.registration.singUp")}
                              <img src={RightArrow} alt="" />
                            </Button>
                          </Form>
                          </>
                          )}
                          {screen === 2 && (
                          <>
                          <h1 className="wrapper__container-card-body-title">
                            {t("pages.registration.singUpSummary")}
                          </h1>
                          <div className="summary-container">
                          <p className="summary-bold">{t("pages.registration.firstName")}</p>
                          <p className="summary-text">{givenName}</p>
                          </div>
                          <div className="summary-container">
                          <p className="summary-bold">{t("pages.registration.lastName")}</p>
                          <p className="summary-text">{sn}</p>
                          </div>
                          <div className="summary-container">
                          <p className="summary-bold">{t("pages.registration.userName")}</p>
                          <p className="summary-text">{userName}</p>
                          </div>
                          <div className="summary-container">
                          <p className="summary-bold">{t("pages.registration.email")}</p>
                          <p className="summary-text">{mail}</p>
                          </div>
                          <div className="summary-container">
                          <p className="summary-bold">{t("pages.registration.preferredLanguage")}</p>
                          <p className="summary-text">{selectedOption === 'en_US' ? 'English' : 'Spanish'}</p>
                          </div>
                          {telephoneNumber && (
                          <div className="summary-container">
                          <p className="summary-bold">{t("pages.registration.mobileNumber")}</p>
                          <p className="summary-text">{telephoneNumber}</p>
                          </div>
                          )}
                          {!disableCaptcha && (
                              <div className="google-captcha">
                                <div className="google-captcha__box">
                                  {googleCaptchaToken && (
                                    <GoogleCaptcha
                                      sitekey={googleCaptchaToken}
                                      onCaptchaChange={this.onCaptchaChange}
                                      captchaReset={captchaReset}
                                    />
                                  )}
                                </div>
                              </div>
                            )}
                          
                          <Button
                              className="wrapper__container-card-body-submit"
                              size="lg"
                              variant="primary"
                              block
                              type="submit"
                              onClick={(e) => this.onSubmit(e)}
                            >
                              {t("pages.registration.submit")}
                              <img src={RightArrow} alt="" />
                            </Button>
                            <div className="text-center wrapper__container-card-register my-3">
                            <p
                          className="summary-link"
                          role="button"
                          tabIndex={0}
                          onClick={() => this.goBackUrl()}
                          onKeyPress={() => this.goBackUrl()}
                        >
                          {t("pages.registration.goBack")}
                        </p>    
                    </div>
                          </>
                          )}

                    {screen === 3 && (
                        <>
                        <h1 className="wrapper__container-card-body-title">
                            {t("pages.registration.singUpVerification")}
                          </h1>
                          <div className="popup__wrapper-body-resend">
                          
                          <p>
                            {t("pages.registration.enterTheVerificationCode")} {verificationOption}
                          </p>
                          <p
                            className="popup__wrapper-body-resend-btn"
                            onClick={(e) => this.resendVerify(e)}
                            role="button"
                            tabIndex={0}
                          >
                            {t("pages.editNumberPopup.resendVerificationCode")}
                          </p>
                          </div>
                          <Form>
                          <Form.Group className="verification-form" controlId="verificationCode">
                          <Form.Label>
                            {t("pages.editNumberPopup.verificationCode")}
                          </Form.Label>
                          <ReactCodeInput fields={8} ref={this.verificationInputRef}
                            placeholder={verificationPlaceholder}
                            className={`verification-input
                              ${verificationCodeError ? "error-verification" : undefined}`
                            }
                            onChange={this.handleChange}
                            removeDefaultStyles={true}
                            autoFocus={false}
                            />
                        {verificationCodeError && (
                          <p className="error-text" id="verification-error">
                          {verificationCodeError && t(verificationCodeError)}
                        </p>
                        )}
                        
                        </Form.Group>
                        
                        <div className="popup__wrapper-body-pleasenote">
                          <span className="popup__wrapper-body-pleasenote-fp">
                          {t("pages.login.pleaseNote")}
                          </span>
                          <span className="popup__wrapper-body-pleasenote-sp">
                          {t("pages.login.doNotClose")}
                          </span>
                        </div>
                        <Button
                              className="wrapper__container-card-body-submit"
                              size="lg"
                              variant="primary"
                              block
                              type="submit"
                              onClick={(e) => this.onVerify(e)}
                            >
                              {t("pages.login.verify")}
                        </Button>
                        <div className="text-center wrapper__container-card-register my-3">
                            <p
                          className="summary-link"
                          role="button"
                          tabIndex={0}
                          onClick={(e) => this.skipUrl(e)}
                          onKeyPress={(e) => this.skipUrl(e)}
                        >
                          {t("pages.registration.skip")}
                        </p>    
                        </div>
                        </Form>
                        </>
                      )}    
                        </>
                      )}
                      {screen === 4 && (
                        <>
                  <div> 
                  <h1 className="wrapper__container-card-body-title has-desc">
                            {t("pages.passwordReset.success")}
                  </h1>
                    <div
                      className="success__card"
                      role="alert"
                      aria-live="polite"
                    >
                      <p className="success__card-text">
                        {t("pages.registration.registrationSuccess")}
                      </p>
                      <p className="success__card-text">
                        <Link to={getLoginUrl()} aria-label= {t("pages.registration.signInLabel")}>
                          {t("pages.registration.registrationSuccessActionBold")}
                        </Link>
                        {t("pages.registration.registrationSuccessAction")}
                      </p>
                    </div>
                </div>
                        </>
                      )}

              {screen === 5 && (
                        <>
                  <div> 
                  <h1 className="wrapper__container-card-body-title has-desc">
                            {t("pages.passwordReset.success")}
                  </h1>
                    <div
                      className="success__card"
                      role="alert"
                      aria-live="polite"
                    >
                      <p className="success__card-text">
                        {t("pages.registration.registrationSuccess")}
                      </p>
                      <p className="success__card-text">
                        {t("pages.registration.registrationVerifySuccess")}
                      </p>
                      <p className="success__card-text">
                        <Link to={getLoginUrl()} aria-label= {t("pages.registration.signInLabel")}>
                          {t("pages.registration.registrationSuccessActionBold")}
                        </Link>
                        {t("pages.registration.registrationSuccessAction")}
                      </p>
                    </div>
                </div>
                        </>
                      )}
                      
                      {verificationTokenExpired && (
                        <ErrorCard
                          title="pages.registration.verifyEmailErrorTitle"
                          description="pages.registration.verifyEmailErrorDesc"
                          anchorText="pages.registration.verifyEmailErrorlinkText"
                          anchorLink="resendVerificationEmail"
                        />
                      )}
                    </div>
                    {screen < 4 && (
                      <div className="text-center wrapper__container-card-register mt-3">
                      {t("pages.registration.alreadyHaveAccount")}{" "}
                      <Link to={getLoginUrl()} aria-label= {t("pages.registration.signInLabel")}>
                        {t("pages.registration.login")}
                      </Link>
                    </div>
                    )}
                    {/* {screen >= 4 && (
                      <div className="text-center wrapper__container-card-register mt-3">
                      <Link to={getLoginUrl()} aria-label= {t("pages.registration.signInLabel")}>
                        {t("pages.registration.login")}
                      </Link>
                    </div>
                    )} */}
                    
                  </div>
                </Col>
              
              </Row>
            </Container>
          </div>
        </div>
            )}
        {isSystemError  && (
                    <SystemDownTime />
                  )}
                  {isSomethingError  && (
                    <SomethingWentWrong />
                    
                  )}
                </>
    );
  }
}

Registration.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};
export default withTranslation()(Registration);
